export default __webpack_public_path__ + "static/media/crossEnable.a2e7d03c.svg";